// src/plugins/openReplay.js
import Tracker from "@openreplay/tracker";

export const tracker = new Tracker({
  projectKey: "V4WsltUGWKIdW6xuBeBC",
  ingestPoint: "https://replays.carrotsolutions.co.kr/ingest",
  crossdomain: {
    parentDomain: "*",
    enabled: true,
  },
  network: {
    capturePayload: true,
  },
  captureIFrames: true,
  __DISABLE_SECURE_MODE: true,
});

export default tracker;
